<template>
  <div>
    <vxe-grid
      ref="skuTable"
      border
      auto-resize
      highlight-hover-row
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="tableData"
      :columns="tableColumns"
      :height="350"
      size="mini"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:opt="{ row, rowIndex }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row, rowIndex)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './sku-table-columns'
export default {
  props: { tableData: { type: Array, default: () => [] } },
  data() {
    return {
      tableColumns: tableColumns(this),
      editRules: {
        amzSkuNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ row }) => {
              const { amzSkuCode, amzSkuNo, _X_ID } = row
              const tableData = this.getTableData().filter(
                (item) => item._X_ID !== _X_ID
              )
              if (tableData && tableData.length) {
                const data = tableData.filter(
                  (item) =>
                    item.amzSkuCode === amzSkuCode && item.amzSkuNo === amzSkuNo
                )
                if (data && data.length) {
                  return new Error(this.$l('tips_table_rules_repeat_amzSkuNo'))
                }
              }
            },
          },
        ],
        asinCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        fnskuCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ row }) => {
              const { amzSkuCode, fnskuCode, _X_ID } = row
              const tableData = this.getTableData().filter(
                (item) => item._X_ID !== _X_ID
              )
              if (tableData && tableData.length) {
                const data = tableData.filter(
                  (item) =>
                    item.amzSkuCode === amzSkuCode &&
                    item.fnskuCode === fnskuCode
                )
                if (data && data.length) {
                  return new Error(this.$l('tips_table_rules_repeat_fnskuCode'))
                }
              }
            },
          },
        ],
        salesPrice: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        salesCurrencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  methods: {
    getTableData() {
      const { fullData } = this.$refs.skuTable.getTableData()
      return (fullData || []).map((item) => {
        const { brandCodeText: brandName } = item
        return { ...item, brandName }
      })
    },
    async validate() {
      const result = await this.$refs.skuTable.validate(true)
      return !result
    },
    del(row, rowIndex) {
      this.$refs.skuTable.remove(row)
      this.$emit('del', row, rowIndex)
    },
  },
}
</script>
